var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAxionColliderLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 631.87 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#ff7611;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.6,50.4V45.6h4.65l-4.65-12L15.07,50.4H9.6l9.6-24H24l9.6,24Z",
    transform: "translate(-9.6 -26.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.6,38.4l-9-12h6l6,8,6-8h6l-9,12,9,12h-6l-6-8-6,8h-6Z",
    transform: "translate(-9.6 -26.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M120,26.4v24h-4.8v-24Z",
    transform: "translate(-9.6 -26.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M177.6,26.4v24h-24v-24Zm-19.2,4.8V45.6h14.4V31.2Z",
    transform: "translate(-9.6 -26.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M201.6,50.4v-24h4.8l14.4,17v-17h4.8v24h-4.8L206.4,33.9V50.4Z",
    transform: "translate(-9.6 -26.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M281.47,26.4h24v4.8h-19.2V45.6h19.2v4.8h-24Z",
    transform: "translate(-9.6 -26.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M353.47,26.4v24h-24v-24Zm-19.2,4.8V45.6h14.4V31.2Z",
    transform: "translate(-9.6 -26.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M401.47,50.4h-24v-24h4.8V45.6h14.4V40.8h4.8Z",
    transform: "translate(-9.6 -26.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M449.47,50.4h-24v-24h4.8V45.6h14.4V40.8h4.8Z",
    transform: "translate(-9.6 -26.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M487.87,26.4v24h-4.8v-24Z",
    transform: "translate(-9.6 -26.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M521.47,50.4v-24h19.2l4.8,4.8V45.6l-4.8,4.8Zm4.8-4.8h12l2.4-2.4V33.82l-2.4-2.62h-12Z",
    transform: "translate(-9.6 -26.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M574.27,36h14.4v4.8h-14.4v4.8h19.2v4.8h-24v-24h24v4.8h-19.2Z",
    transform: "translate(-9.6 -26.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M627.07,40.8h-4.8v9.6h-4.8v-24h24V40.8H633l8.48,9.6h-5.93Zm-4.8-9.6V36h14.4V31.2Z",
    transform: "translate(-9.6 -26.4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAxionColliderLogo);
export default __webpack_public_path__ + "static/media/AxionColliderLogo.805cbed932c4fd23b9a44f0d3bdd7106.svg";
export { ForwardRef as ReactComponent };